// @ts-ignore
window.Dashboard = class {

    layout: {};

    init(layout = {}) {

        this.layout = layout;

        // look for required dashboard elements
        const dashboard = document.getElementById('dashboard');
        if (!dashboard) {
            alert('#dashboard element not found.');
            return false;
        }

        // check placeholders
        let placeholders = document.body.querySelectorAll('[id^=dashboard-placeholder-]');
        if (!placeholders.length) {
            alert('You need to define placeholders for the dashboard to work.')
        }
        placeholders.forEach((pl: HTMLElement) => {
            pl.style.minHeight = '42px';
        });


        // place the widgets according to user config
        if (this.layout) {
            for (let widgetId in this.layout) {
                // look for widget in html
                let widget = document.getElementById(widgetId);
                if (widget) {
                    let placeholder = document.getElementById(this.layout[widgetId].placeholder);
                    if (this.layout[widgetId].collapsed) {
                        // @ts-ignore
                        $(widget).CardWidget('collapse');
                        // to make it quick
                        widget.querySelector('.card-body')[0].style.display = 'none';
                    }
                    if (placeholder) {
                        placeholder.appendChild(widget);
                    } else {
                        dashboard.appendChild(widget);
                    }
                }
            }
        }

        // place the remaining widgets (new ones)
        document.body.querySelectorAll('#dashboard-store [id^=dashboard-widget-]').forEach(function (widget, index) {
            placeholders[index % placeholders.length].appendChild(widget);
        });

        // make them move
        // @ts-ignore
        $('[id^=dashboard-placeholder-]').sortable({
            placeholder: 'sort-highlight',
            connectWith: '[id^=dashboard-placeholder-]',
            handle: '.card-header, .nav-tabs',
            forcePlaceholderSize: true,
            zIndex: 999999
        });
        $('[id^=dashboard-placeholder-] .card-header, [id^=dashboard-placeholder-] .nav-tabs-custom').css('cursor', 'move');

        setInterval(this.saveLayout, 1000);
    }

    saveLayout() {
        let layout = {};
        $('[id^=dashboard-widget-]').each(function () {
            layout[this.id] = {
                placeholder: $(this).closest('[id^=dashboard-placeholder-]').attr('id'),
                collapsed: this.classList.contains('collapsed-card')
            }
        });

        if (JSON.stringify(this.layout) !== JSON.stringify(layout)) {
            this.layout = JSON.parse(JSON.stringify(layout));
            $.post('/site/save-dashboard', {'dashboard-layout': JSON.stringify(layout)});
        }
    }
};
